import { AliRecord } from "services/ALIRecord";
import { Criteria } from "services/APIBase.d";
import { Msag } from "services/MSAGRecord";

export interface DiscrepData {
  msag_change_response?: MsagChangeResponse;
  ali_change_response?: AliChangeResponse;
  lvf_response?: LVFResp;
  ali_error_response?: AliErrorResponse;
  table_name: string;
}

export type AliChangeResponse = {
  ali: AliRecord;
  ali_change: AliChange;
};

export type AliChange = {
  discrep_id?: number;
  CPN?: string;
  ORG_NAM?: string;
  ORG_HNO?: string;
  ORG_HNS?: string;
  ORG_PRD?: string;
  ORG_STN?: string;
  ORG_STS?: string;
  ORG_POD?: string;
  ORG_MCN?: string;
  ORG_STA?: string;
  ORG_LOC?: string;
  ORG_Comments?: any;
  EDIT_NAM: string;
  EDIT_HNO: string;
  EDIT_HNS: string;
  EDIT_PRD: string;
  EDIT_STN: string;
  EDIT_STS: string;
  EDIT_POD: string;
  EDIT_MCN: string;
  EDIT_STA: string;
  EDIT_LOC: string;
  EDIT_Comments: string;
  NOTES?: string;
};

export function createAliChangeDiscrepancyFromAliRecord(
  record: AliRecord,
): AliChange {
  return {
    CPN: record.CPN || "",
    EDIT_NAM: record.NAM || "",
    EDIT_HNO: record.HNO || "",
    EDIT_HNS: record.HNS || "",
    EDIT_PRD: record.PRD || "",
    EDIT_STN: record.STN || "",
    EDIT_STS: record.STS || "",
    EDIT_POD: record.POD || "",
    EDIT_MCN: record.MCN || "",
    EDIT_STA: record.STA || "",
    EDIT_LOC: record.LOC || "",
    EDIT_Comments: record.Comments || "",
    NOTES: record.NOTES || "",
  };
}

export type LVFResp = {
  ali: AliRecord;
  lvf: LVFChange;
};

export type LVFChange = {
  discrep_id: number;
  valid?: string;
  invalid?: string;
  unchecked?: string;
  ORG_HNP?: string;
  ORG_HNO?: string;
  ORG_HNS?: string;
  ORG_PRD?: string;
  ORG_STN?: string;
  ORG_STS?: string;
  ORG_POD?: string;
  ORG_MCN?: string;
  ORG_lecCOI?: string;
  ORG_STA?: string;
  ORG_LOC?: string;
  EDIT_HNP?: string;
  EDIT_HNO?: string;
  EDIT_HNS?: string;
  EDIT_PRD?: string;
  EDIT_STN?: string;
  EDIT_STS?: string;
  EDIT_POD?: string;
  EDIT_MCN?: string;
  EDIT_lecCOI?: string;
  EDIT_STA?: string;
  EDIT_LOC?: string;
  EDIT_requested?: string;
};

export type AliErrorResponse = {
  error: AliErrorChange;
  discrep: Discrepancy;
};

export type AliErrorChange = {
  discrep_id: number;
  OBJECTID?: number;
  UNIQUEID?: string;
  TIMESTAMP?: string;
  LABEL?: string;
  USERID?: string;
  CALLTYPE?: string;
  ORG_TELNUM?: string;
  ORG_NAME?: string;
  ORG_ADDR?: string;
  ORG_COMM?: string;
  ORG_ESN?: string;
  EDIT_TELNUM?: string;
  EDIT_NAME?: string;
  EDIT_ADDR?: string;
  EDIT_COMM?: string;
  EDIT_ESN?: string;
  COMMENTS?: string;
  CHK_MISROUTE?: string;
  CHK_NORECORD?: string;
  CHK_ALI?: string;
  STATUS?: string;
  NOTES?: string;
  CREATEDBY?: string;
  JURISID?: number;
  ASSIGNEDTOJURISID?: number;
  ALI?: string;
  CASE_STATUS?: string;
  EDIT_LOCINFO?: string;
  ORG_LOCINFO?: string;
  PSAP_NAME?: string;
  DATE_TIME_CALL?: string;
  DATE_TIME_CREATED?: string;
  CALLTAKER_NAME?: string;
  ALI_TIMESTAMP?: string;
  CALLERNAME?: string;
  CELLSECTORID?: null;
  CELLSECTORSECONDARYID?: null;
  CELLSECTORSECONDARYID2?: null;
  COMMUNITY?: null;
  E911FIRERESPONDER?: null;
  E911LAWENFORCEMENTRESPONDER?: null;
  E911MEDICALRESPONDER?: null;
  ERRORDESCRIPTION?: string;
  ESN?: string;
  GEOPROCESSINGRESULT?: string;
  GEOPROCESSINGRESULTCODE?: string;
  ID?: string;
  LATITUDE?: null;
  LOCATIONINFO?: null;
  LOG_TIMESTAMP?: string;
  LONGITUDE?: null;
  POSITIONID?: null;
  STREETADDRESS?: null;
  TELEPHONENUMBER?: string;
  TOLERANCEZONERADIUS?: string;
  WIRELESSCARRIER?: null;
  X?: null;
  Y?: null;
};

export type MsagChangeResponse = {
  msag: Msag;
  msag_change: MsagChange;
};

export type MsagChange = {
  discrep_id: number;
  ORG_msag_id: string;
  ORG_LowRange?: string;
  ORG_HiRange?: string;
  ORG_Side?: string;
  ORG_PRD?: string;
  ORG_STN: string;
  ORG_STS?: string;
  ORG_POD?: string;
  ORG_MCN: string;
  ORG_STA?: string;
  ORG_CountyID?: string;
  ORG_esn?: string;
  ORG_GeneralUse?: string;
  EDIT_LowRange?: string;
  EDIT_HiRange?: string;
  EDIT_Side?: string;
  EDIT_PRD?: string;
  EDIT_STN: string;
  EDIT_STS?: string;
  EDIT_POD?: string;
  EDIT_MCN: string;
  EDIT_STA?: string;
  EDIT_CountyID?: string;
  EDIT_esn?: string;
  EDIT_GeneralUse?: string;
  NEW_msag_id?: string;
  req_type: string;
};

export type Discrepancy = {
  id: number;
  src_id?: string;
  ANI?: string;
  CBN?: string;
  CPF?: string;
  sop_id?: number;
  COS?: string;
  dtype: number;
  status: number;
  question?: number;
  last_modified?: string;
  occurred?: string;
  submitted?: string;
  viewable?: string;
  resolved?: string;
  verified?: string;
  completed?: string;
  created_by?: string;
  submitted_by?: string;
  modified_by?: string;
  web_login?: string;
  state?: string;
  county?: string;
  inESN?: string;
  jurisdiction?: string;
  software_src?: string;
  table_name?: string;
  ticket?: number;
  age?: string;
  SOPName?: string;
  Criteria?: Criteria[];
};
